import { Alert } from '@synoptic/ui-kit/alert/alert.js';
import { ClockIcon } from '@synoptic/ui-kit/icons/react/clock.js';
import { space } from '@synoptic/ui-kit/tokens.js';
import { ReactNode } from 'react';

export const DelayedPreviewAlert = ({ children }: { children: ReactNode }) => {
  return (
    <Alert
      style={{ marginBottom: space.s16 }}
      icon={<ClockIcon />}
      data-testid="delayed-preview-alert"
      color="prominent"
    >
      {children}
    </Alert>
  );
};
